<div class="modal-content">
    <div class="modal-status bg-danger"></div>
    <div class="modal-body text-center py-4">
        <div class="modal-icon"><svg xmlns="http://www.w3.org/2000/svg" class="text-danger" width="3.5rem"
                height="3.5rem" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path
                    d="M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z">
                </path>
                <path d="M12 9v4"></path>
                <path d="M12 17h.01"></path>
            </svg></div>
        <h4 class="modal-title mb-2">WARNING</h4>
        <div class="text-muted" style="font-size: 1.2rem;">{{Message}}</div>
        <div class="text-muted text-start" style="font-size: 0.9rem" *ngIf="Message2 != null && Message2 != ''">
            <hr />
            <span [innerHTML]="Message2"></span>
        </div>
    </div>
    <div class="modal-footer" *ngIf="showOk">
        <div class="w-100">
            <div class="row">
                <div class="col"></div>
                <div class="col">
                    <button type="button" (click)="close(true)"
                        class="w-100 text-truncate btn btn-default btn-ok btn-danger">OK</button>
                </div>
                <div class="col"></div>
            </div>
        </div>
    </div>
</div>